import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import { deepMerge } from "swiipe.portal.shared"

export const initializeLocales = () => {
    const shared = {
        en: {
            translation: require("swiipe.portal.shared/src/locale/lang/en.json"),
        },
        da: {
            translation: require("swiipe.portal.shared/src/locale/lang/da.json"),
        },
        fr: {
            translation: require("swiipe.portal.shared/src/locale/lang/fr.json"),
        },
        nl: {
            translation: require("swiipe.portal.shared/src/locale/lang/nl.json"),
        },
        no: {
            translation: require("swiipe.portal.shared/src/locale/lang/no.json"),
        },
    }
    const own = {
        en: {
            translation: require("./lang/en.json"),
        },
        da: {
            translation: require("./lang/da.json"),
        },
        sv: {
            translation: require("./lang/sv.json"),
        },
        fr: {
            translation: require("./lang/fr.json"),
        },
        nl: {
            translation: require("./lang/nl.json"),
        },
        no: {
            translation: require("./lang/no.json"),
        },
    }
    i18next
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            resources: deepMerge({}, shared, own),
            lng: navigator.language.split("-")[0],
            fallbackLng: "en",

            interpolation: {
                escapeValue: false,
            },
        })
}
